/**
 *
 * SwitchField
 *
 */

import React from 'react';
import {
  Wrapper,
  Label,
  InputWrapper,
  Input,
  Indicator,
} from './styledComponents';

const SwitchField = ({ label, input, checked, disabled, disabledValue, className, baseSwitch, ...props}) => {
  const value = input.value === "" ? (checked ? checked : false ) : input.value ;
  return(
  <Wrapper>
    <Label>
      {label}
    </Label>
    <InputWrapper>
      <Indicator
        value={value}
        disabled={disabled}
        disabledValue={disabledValue}
        className={className}
      />
      <Input disabled={disabled} className={className} value={value} {...input} {...props} type='checkbox' onChange={ checked && !baseSwitch ? () => { props.clearPassword(); props.turnOffPassword()} : () => input.onChange(input.value ? false : true)}/>
    </InputWrapper>
  </Wrapper>
);}

export default SwitchField;



// WEBPACK FOOTER //
// ./src/components/SwitchField/index.js